import React from 'react';
import About from 'views/About';

const AboutPage = () => {
  return <About />;
};

export default AboutPage;
